import { useEffect } from "react";
import "./contact.scss";
import { gsap } from "gsap-trial";

const Contact = () => {
    useEffect(() => {
        gsap.fromTo(
            ".opacity-anim",
            {
                opacity: 0,
            },
            {
                opacity: 1,
                duration: 1,
                ease: "power2.out",
            }
        );
    }, []);

    return (
        <>
            <div className="contain-wrapper">
                <div className="contact-one contain opacity-anim">
                    <div className="wrapper">
                        <p>
                            Home / <span className="volt">Contact</span>
                        </p>
                    </div>
                    <div>
                        <h1>Get in touch</h1>
                    </div>
                    <div className="copy-wrapper">
                        <h3>
                            Space Industrial is a joint venture between
                            Marchmont and Invesco Real Estate.
                            <br /> For more information, please enquire with our
                            team.
                        </h3>
                    </div>
                </div>
            </div>
            <div className="contain-wrapper">
                <div className="contact-two contain opacity-anim">
                    <div className="contacts-wrapper">
                        <h2>Lettings</h2>
                        <div className="contacts">
                            <div className="contact">
                                <p>George Hatcher</p>
                                <a href="tel:++447542607085">
                                    <p>+44 (0)7542 607 085</p>
                                </a>
                                <a href="mailto:gh@marchmont-im.com">
                                    <p className="volt">gh@marchmont-im.com</p>
                                </a>
                            </div>
                            <div className="contact">
                                <p>
                                    Tim Clarke                                  
                                </p>
                                <a href="tel:+447771393994">
                                    <p>+44 (0)7771 393 994</p>
                                </a>
                                <a href="mailto:tc@marchmont-im.com">
                                    <p className="volt">tc@marchmont-im.com</p>
                                </a>
                            </div>
                        </div>
                    </div>
                    <div className="contacts-wrapper">
                        <h2>Acquisitions</h2>
                        <div className="contacts">
                            <div className="contact">
                                <p>James Rodwell</p>
                                <a href="tel:+447928903719">
                                    <p>+44 (0)7928 903 719</p>
                                </a>
                                <a href="mailto:jr@marchmont-im.com">
                                    <p className="volt">jr@marchmont-im.com</p>
                                </a>
                            </div>
                            <div className="contact">
                                <p>Cameron Fraser</p>
                                <a href="tel:+447557819963">
                                    <p>+44 (0)7557 819 963</p>
                                </a>
                                <a href="mailto:cf@marchmont-im.com">
                                    <p className="volt">cf@marchmont-im.com</p>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Contact;
